import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEmptyImg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 105 105" {...props}>
    <path fill="#F3F2F3" d="M0 0h105v105H0z" />
    <path
      fill="#E6E6E6"
      d="M97 52.43c0 25.09-20.147 45.43-45 45.43S7 77.52 7 52.43 27.147 7 52 7s45 20.34 45 45.43"
    />
    <path
      fill="#F3F2F3"
      d="M85.464 52.558c0 18.668-14.99 33.801-33.481 33.801s-33.481-15.133-33.481-33.8c0-18.669 14.99-33.802 33.48-33.802 18.492 0 33.482 15.133 33.482 33.801"
    />
  </svg>
);
export default SvgEmptyImg;
